module.exports = __webpack_public_path__ + "img/banner.c43be57f.jpg";